import initSlider from '../sliders/initSlider';
import initChoicesInstance from '../initChoicesInstance';

document.addEventListener('DOMContentLoaded', (e) => {
  const assetsSlider = initSlider('[data-assets-slider]', {
    slidesPerView: 'auto',
    slideToClickedSlide: true,
    spaceBetween: 24,
  });

  /*  */

  const assetsSelect = document.querySelector('[data-multiple-choice]');

  const multipleChoice = initChoicesInstance(assetsSelect, {
    removeItems: true,
    removeItemButton: true,
  });

  assetsSelect.addEventListener('choice', setTotalSum);
  assetsSelect.addEventListener('removeItem', (e) => {
    const { options } = assetsSelect;
    const selectedOptions = [...options].filter((option) => option.selected);
    console.warn(selectedOptions.length);

    if (selectedOptions.length <= 1) return;
    // console.warn(assetsSelect.options.filter);
    // console.warn(assetsSelect);
    // console.warn(multipleChoice);
    // console.warn(e);
    setTotalSum();
  });

  /*  */

  const singleSelect = document.querySelector('[data-single-choice]');
  const singleSelectInstance = initChoicesInstance(singleSelect);

  singleSelect.addEventListener('choice', setTotalSum);

  /*  */

  // $('.brand__item').on('change', function() {
  //   toggleBrand(this);
  // });

  // $('.brand-selection__cancel-list').on('click', 'li', function() {
  //   const itemValue = $(this).data('value');
  //   const dropdownListItems = document.getElementsByClassName('brand__item');

  //   $(this).remove();

  //   for (let item of dropdownListItems) {
  //     const currentItemValue = item.dataset.value;

  //     if (currentItemValue === itemValue) {
  //       item.querySelector('input[type="checkbox"').checked = false;
  //     }
  //   }

  //   // checkBrandsLength();

  // setTotalSum();
  // });

  $('#investment_sum').on('input', function () {
    const val = parseFloat(this.value);
    const totalProfit = document.getElementById('total_profit');

    if (isNaN(val) || val <= 0 || val === '') {
      totalProfit.textContent = '0'.toFixed(2);
      return false;
    }

    // if (isInputValid()) {
      totalProfit.textContent = countTotalProfit(val).toFixed(2);
    // }
  });
});

// Profitability calculator data
const stockPriceInDollars = {
  Apple: {
    now: 190,
    '3 months ago': 218,
    '6 months ago': 166,
    '9 months ago': 200,
    '12 months ago': 213,
    '24 months ago': 360,
  },
  Tesla: {
    now: 1777,
    '3 months ago': 1598,
    '6 months ago': 1718,
    '9 months ago': 1926,
    '12 months ago': 1966,
    '24 months ago': 2918,
  },
  Ferrari: {
    now: 1217,
    '3 months ago': 1076,
    '6 months ago': 1116,
    '9 months ago': 1188,
    '12 months ago': 1216,
    '24 months ago': 1498,
  },
  Facebook: {
    now: 298,
    '3 months ago': 337,
    '6 months ago': 307,
    '9 months ago': 238,
    '12 months ago': 241,
    '24 months ago': 1388,
  },
  Nvidia: {
    now: 106,
    '3 months ago': 106,
    '6 months ago': 106,
    '9 months ago': 130,
    '12 months ago': 136,
    '24 months ago': 199,
  },
};

// const toggleBrand = (brand) => {
//   const value = brand.dataset.value;
//   const checkbox = brand.querySelector('input[type="checkbox"]').checked;

//   if (checkbox) {
//     document.getElementById('brand_list').insertAdjacentHTML('beforeend', `<li class="brand-selection__cancel-item" data-value="${value}">${value}</li>`);
//   } else {
//     const brandList = document.getElementById('brand_list');
//     const brandListItems = brandList.getElementsByClassName('brand-selection__cancel-item');

//     for (let item of brandListItems) {
//       const currentItemValue = item.dataset.value;

//       if (currentItemValue === value) {
//         item.remove();
//       }
//     }
//   }

//   // checkBrandsLength();

//   setTotalSum();
// };

// const checkBrandsLength = () => {
//   const brandList = document.getElementById('brand_list');
//   const brandListItems = brandList.getElementsByTagName('li');
//   const checkedDropdownItems = document.querySelectorAll('.brand__item input[type="checkbox"]:checked');

//   if (brandListItems.length <= 1) {
//     $(brandListItems).addClass('disabled');
//     $(checkedDropdownItems).closest('.brand__item').addClass('disabled');
//   } else {
//     $(brandListItems).removeClass('disabled');
//     $(checkedDropdownItems).closest('.brand__item').removeClass('disabled');
//   }
// }

// const checkIfBrandInList = (brand) => {
//   const brandList = document.getElementById('brand_list');
//   const brandListItems = brandList.getElementsByTagName('li');

//   for (let item of brandListItems) {
//     if (item.dataset.value === brand) return false;
//   }

//   brandList.insertAdjacentHTML('beforeend', `<li class="brand-selection__cancel-item" data-value="${brand}">${brand}</li>`);
// }

const isInputValid = () => {
  const regExp = '[-+]?[0-9]*.?[0-9]+';
  const investmentSumInput = document.getElementById('investment_sum');
  const investmentSumValue = investmentSumInput.value;

  if (!investmentSumValue.match(regExp)) {
    investmentSumInput.classList.add('invalid');
    return false;
  }

  return true;
};

function findChosenShares() {
  const assetsSelect = document.getElementById('assets');
  const assetsList = [...assetsSelect.querySelectorAll('option')];
  const chosenAssets = assetsList.filter((item) => item.selected).map((item) => item.value);

  // console.warn('chosenAssets', chosenAssets);

  return chosenAssets;
}

function checkInvestmentPeriod() {
  const investmentPeriodSelect = document.getElementById('investment_period');
  const investmentPeriodValue = investmentPeriodSelect.value;

  return investmentPeriodValue;
}

function getCurrentCost(list) {
  let sum = 0;

  for (let item of list) {
    try {
      const currentPrice = parseFloat(stockPriceInDollars[item].now);
      sum += currentPrice;
    } catch (error) {
      console.log(`There is no instrument ${item} in the list`);
    }
  }

  return sum;
}

function getCostAfterCertainPeriod(list) {
  let sum = 0;

  for (let item of list) {
    try {
      const period = parseFloat(stockPriceInDollars[item][checkInvestmentPeriod()]);
      sum += period;
    } catch (error) {
      console.log(`There is no instrument ${item} in the list`);
    }
  }

  return sum;
}

function countTotalProfit(investmentSum) {
  const allSharesCurrentCost = getCurrentCost(findChosenShares());
  const allSharesCostInCertainPeriod = getCostAfterCertainPeriod(findChosenShares());
  // console.warn('allSharesCurrentCost', allSharesCurrentCost);
  // console.warn('allSharesCostInCertainPeriod', allSharesCostInCertainPeriod);

  let totalSum = (investmentSum / allSharesCurrentCost) * allSharesCostInCertainPeriod;

  return totalSum;
}

const setTotalSum = () => {
  const investmentSumInput = document.getElementById('investment_sum');
  const investmentSumValue = parseFloat(investmentSumInput.value);
  const totalProfit = document.getElementById('total_profit');

  if (isNaN(investmentSumValue) || investmentSumValue <= 0 || investmentSumValue === '') {
    totalProfit.textContent = '0'.toFixed(2);
    return false;
  }

  // if (isInputValid()) {
    totalProfit.textContent = countTotalProfit(investmentSumValue).toFixed(2);
  // }
};
